import { render, staticRenderFns } from "./ProformaListing.vue?vue&type=template&id=6b4db758"
import script from "./ProformaListing.vue?vue&type=script&lang=js"
export * from "./ProformaListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports